var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F2F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C29.523 14 34 18.477 34 24C34 29.523 29.523 34 24 34C22.1782 34.0028 20.3905 33.5054 18.832 32.562L15.8 33.454C15.6259 33.5052 15.4413 33.5086 15.2654 33.4638C15.0896 33.4189 14.9291 33.3276 14.8008 33.1992C14.6725 33.0709 14.5811 32.9104 14.5363 32.7346C14.4914 32.5587 14.4948 32.3741 14.546 32.2L15.438 29.168C14.4951 27.6093 13.9977 25.8218 14 24C14 18.477 18.477 14 24 14ZM20.5 22.5C20.1022 22.5 19.7207 22.658 19.4393 22.9393C19.158 23.2206 19 23.6022 19 24C19 24.3978 19.158 24.7794 19.4393 25.0607C19.7207 25.342 20.1022 25.5 20.5 25.5C20.8978 25.5 21.2794 25.342 21.5607 25.0607C21.842 24.7794 22 24.3978 22 24C22 23.6022 21.842 23.2206 21.5607 22.9393C21.2794 22.658 20.8978 22.5 20.5 22.5ZM27.5 22.5C27.1022 22.5 26.7207 22.658 26.4393 22.9393C26.158 23.2206 26 23.6022 26 24C26 24.3978 26.158 24.7794 26.4393 25.0607C26.7207 25.342 27.1022 25.5 27.5 25.5C27.8978 25.5 28.2794 25.342 28.5607 25.0607C28.842 24.7794 29 24.3978 29 24C29 23.6022 28.842 23.2206 28.5607 22.9393C28.2794 22.658 27.8978 22.5 27.5 22.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatListIcon);
export default __webpack_public_path__ + "static/media/chatListIcon.56a7f438fe891ebf3e095fb63f7fdada.svg";
export { ForwardRef as ReactComponent };